import { NumberValueSchema } from "../number/shape.ts";
import { BooleanValueSchema } from "../boolean/shape.ts";
import { StringValueSchema } from "../string/shape.ts";
import z from "zod";

export const ListValueSchema = z.union([
  z.array(StringValueSchema),
  z.array(BooleanValueSchema),
  z.array(NumberValueSchema),
]);
export type ListValueType = z.infer<typeof ListValueSchema>;
